import React, {Fragment, useEffect, useState} from "react";
import {getParams} from "../../utils/hooks/getParams";
import {useDispatch} from "react-redux";

const FilterOnlyTrashed = (props) => {
    const dispatch = useDispatch();
    const {getPageItems} = props;

    const [onlyTrashed, setOnlyTrashed] = useState(!!getParams().only_trashed || false);
    const [isFirst, setIsFirst] = useState(true);

    useEffect(() => {
        const params = getParams();
        if (!isFirst) {
            dispatch(getPageItems(1, params))
        }
        setIsFirst(false);
    }, [onlyTrashed])

    const handleChange = () => {
        setOnlyTrashed(!onlyTrashed);

        // Get the current URL and params
        const url = new URL(window.location);
        
        // Reset page to 1
        url.searchParams.set('page', 1);
        
        if (!onlyTrashed) {
            // If we're turning it on, set the param
            url.searchParams.set('only_trashed', String(!onlyTrashed));
            
            // Remove with_trashed param if it exists (they are mutually exclusive)
            if (url.searchParams.has('with_trashed')) {
                url.searchParams.delete('with_trashed');
            }
        } else {
            // If we're turning it off, remove the param
            url.searchParams.delete('only_trashed');
        }
        
        window.history.pushState({}, '', url);
    };

    return (
        <Fragment>
            <div className="form-check form-switch">
                <input className="form-check-input"
                       type="checkbox"
                       id="filterOnlyTrashed"
                       onChange={handleChange}
                       checked={onlyTrashed}
                />
                <label className="form-check-label" htmlFor="filterOnlyTrashed">
                    Faqat o'chirilgan sotuvlar
                </label>
            </div>
        </Fragment>
    )
}

export default FilterOnlyTrashed; 